/**
 * Selmani Note:
 * 
 * creatine-limit.js
 * Enforces a hard maximum of 1 unit for the 'beofit-creatine-monohydrate' product
 * across the entire checkout pipeline.
 *
 * Strategy:
 *  1. Capture-phase listener on all checkout button clicks.
 *  2. Fetch current cart state via AJAX.
 *  3. If the restricted item has qty > 1: abort the click, show a toast,
 *     force quantity back to 1 via /cart/change.js, then re-render the page.
 */

(function () {
  'use strict';

  const RESTRICTED_HANDLE = 'beofit-creatine-monohydrate';
  const TOAST_DURATION_MS = 4000;

  function showToast(message) {
    const existing = document.getElementById('creatine-limit-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.id = 'creatine-limit-toast';
    toast.setAttribute('role', 'alert');
    toast.setAttribute('aria-live', 'assertive');
    toast.style.cssText = [
      'position:fixed',
      'bottom:24px',
      'left:50%',
      'transform:translateX(-50%)',
      'background:#1a1a1a',
      'color:#fff',
      'padding:14px 22px',
      'border-radius:8px',
      'font-size:14px',
      'line-height:1.5',
      'max-width:340px',
      'text-align:center',
      'box-shadow:0 4px 18px rgba(0,0,0,.35)',
      'z-index:99999',
      'opacity:0',
      'transition:opacity .25s ease',
    ].join(';');
    toast.textContent = message;

    document.body.appendChild(toast);
    requestAnimationFrame(() => { toast.style.opacity = '1'; });

    setTimeout(() => {
      toast.style.opacity = '0';
      toast.addEventListener('transitionend', () => toast.remove(), { once: true });
    }, TOAST_DURATION_MS);
  }

  /* ------------------------------------------------------------------ */
  /* Cart helpers                                                         */
  /* ------------------------------------------------------------------ */

  function fetchCart() {
    return fetch(
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/') + 'cart.js',
      { headers: { 'Content-Type': 'application/json' } }
    ).then((r) => r.json());
  }

  function forceQuantityToOne(lineKey) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 1 }),
    }).then((r) => r.json());
  }

  /* ------------------------------------------------------------------ */
  /* Checkout-button interceptor                                          */
  /* ------------------------------------------------------------------ */

  let bypassNext = false;

  function handleCheckoutClick(event) {
    const btn = event.target.closest(
      'button[name="checkout"], input[name="checkout"], #checkout, .checkout-button'
    );
    if (!btn) return;

    if (bypassNext) {
      bypassNext = false;
      return; 
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    fetchCart()
      .then((cart) => {
        const restricted = (cart.items || []).find(
          (item) => item.handle === RESTRICTED_HANDLE && item.quantity > 1
        );

        if (!restricted) {
          /* Cart is clean — re-fire the click, bypassing our guard. */
          bypassNext = true;
          btn.click();
          return;
        }

        showToast(
          'This promotional product is limited to 1 per order. ' +
          'Your cart has been automatically corrected.'
        );

        forceQuantityToOne(restricted.key)
          .then(() => {
            const cartDrawer = document.getElementById('Cart-Drawer');
            if (cartDrawer && typeof window.__cartDrawerRefresh === 'function') {
              window.__cartDrawerRefresh();
            } else {
              window.location.reload();
            }
          })
          .catch(() => {
            window.location.reload();
          });
      })
      .catch(() => {
        /* Cart fetch failed — fail open so checkout is never permanently blocked. */
        bypassNext = true;
        btn.click();
      });
  }

  document.addEventListener('click', handleCheckoutClick, true);
})();
